import React from 'react';
import PropTypes from 'prop-types';
import { useUser } from '@lore/auth';
import RedirectChoice from './RedirectChoice';
import useRouter from '../../../hooks/useRouter';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

export default function ExploreNearbyOpportunitiesChoice(props) {
  const { history } = useRouter();

  const currentUser = useUser();

  return (
    <RedirectChoice
      icon={MagnifyingGlassIcon}
      title="Explore opportunities near me."
      onClick={() => history.push({
        pathname: '/projects-events',
        search: stringify({
          locationCondition: JSON.stringify({
            address: currentUser.data.zipCode,
            latitude: currentUser.data.latitude,
            longitude: currentUser.data.longitude,
            radius: 50
          })
        })
      })}
    />
  );
};
